import Vue from "vue";

Vue.directive("close-mobile-navigation",
    {
        bind(el)
        {
            el.onclick = () => ceresStore.commit("setIsMobileNavigationOpen", false);
        }
    });
